import PropTypes from "prop-types";
import Dispatcher from "Dispatcher";
import typeCheckingStore from "data/util/typeCheckingStore";
import ContextedReduceStore from "data/util/ContextedReduceStore";
import ValidationTreeActions from "data/ValidationTreeActions";

export const toggleFilter = (ctx, filter) => ({
    ...ctx,
    filters: {
        ...ctx.filters,
        [filter]: !ctx.filters[filter],
    }
});

class ValidationTreeStore extends ContextedReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialContext() {
        return {
            filters: {
                illegal: true,
                warning: true,
                ok: false,
                all: true,
            },
        };
    }

    reduceContext(ctx, action) {
        switch (action.type) {
            case ValidationTreeActions.TOGGLE_FILTER:
                return toggleFilter(ctx, action.filter);
            default:
                return ctx;
        }
    }

    getFilters(contextId) {
        return this.getState(contextId).filters;
    }

}

ValidationTreeStore.contextTypes = {
    filters: PropTypes.shape({
        illegal: PropTypes.bool.isRequired,
        warning: PropTypes.bool.isRequired,
        ok: PropTypes.bool.isRequired,
        all: PropTypes.bool.isRequired,
    }).isRequired,
};

export default typeCheckingStore(new ValidationTreeStore());



// WEBPACK FOOTER //
// ./app/data/ValidationTreeStore.js